import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Grid, Row, Col} from 'react-bootstrap'
import PageTitle from '../common/page-title/index'
import ArticleList from '../common/article/article-list'
import InlineCKEditor from '../common/editor/inline-editor'
import {getLatestNews} from '../../actions/latest-news'
import {loadPageContent} from '../../actions/content';

class LatestNews extends Component {

  constructor(props) {
    super(props);

    this.pageSlug = 'latest-news';
  }

  componentWillMount() {
    this.props.dispatch(getLatestNews());
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  render() {
    return (
      <div className="latest-news container">
        <PageTitle>News</PageTitle>
        <InlineCKEditor
          identifier={`${this.pageSlug}_content_text`}
          onContentSaved={this.handleContentSaved}
          contents={this.props.contents[`${this.pageSlug}_content_text`]}
        />
        <ArticleList articles={this.props.latestNews}/>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    latestNews: state.latestNews.latestNews,
    fetching:   state.latestNews.fetching,
    fetched:    state.latestNews.fetched,
    contents:   state.content.list
  };
};

export default connect(mapStateToProps)(LatestNews);



// WEBPACK FOOTER //
// ./src/components/latest-news/index.jsx